import React from 'react'
import { Card, Flex } from 'antd'
import dayjs from 'dayjs'
import _ from 'lodash'
import Title from 'antd/es/typography/Title'
import { BarChart } from '@mui/x-charts'

export default function DaySortBySlotsChart ({ slots }) {
  const format = (days) => {
    return Object.keys(days).map((day) => ({ name: day, value: days[day].length }))
  }

  const days = _.groupBy(slots, (slot) => {
    return dayjs(slot.appointment_date).format('dddd')
  })

  return (
    <Card>
      <Flex vertical>
        <Title level={5} style={{ textAlign: 'center' }}>
          {'Journées classées par consultations'}
        </Title>
        <BarChart
          dataset={format(days)}
          xAxis={[{ scaleType: 'band', dataKey: 'name' }]}
          series={[{ dataKey: 'value' }]}
          height={200} />
      </Flex>
    </Card>
  )
}
